// BoardSwitcher — pick which board layout to run today.
//
// ⚠️ ONE BOARD LEFT, SO THIS RENDERS NOTHING (2026-08-17, asked for).
// A, B and C were three alternative layouts trialled alongside the original on
// real days. That trial is over and they were taken off the nav menu; leaving
// them here would put them back in front of people on the board page itself.
//
// It returns null rather than showing a one-option select, for two reasons: a
// control with a single choice is furniture, and on /board-a the select would
// have displayed "OR Board (original)" — naming a layout the reader is NOT
// looking at, because `current` is no longer in the list.
//
// The component and its four call sites stay, and the routes stay mounted, so
// restoring the trial is one line in BOARDS below.
//
// A plain <select> on purpose. This is a preference control that gets used a
// handful of times, not a command, and a native select is keyboard-operable,
// screen-reader-labelled and understood by everyone without being taught.

import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { C, MONO } from "./panelCard.styles";

export const BOARDS = [
  { path: "/board", label: "OR Board (original)" },
];

export default function BoardSwitcher({ compact = false }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  // `/panel` is the original route of Board C, kept working so an open tab or a
  // bookmark does not break.
  const current = pathname === "/panel" ? "/board-c" : pathname;

  // Nothing to choose between — see the note at the top of the file.
  if (BOARDS.length < 2) return null;

  return (
    <label
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        fontSize: 12,
        color: C.muted,
      }}
    >
      <span style={{ fontFamily: MONO, fontSize: 11, letterSpacing: "0.06em" }}>
        {compact ? "BOARD" : "BOARD LAYOUT"}
      </span>
      <select
        value={BOARDS.some((b) => b.path === current) ? current : "/board"}
        onChange={(e) => navigate(e.target.value)}
        aria-label="Choose which board layout to use"
        style={{
          minHeight: 32,
          font: "inherit",
          fontSize: 12.5,
          padding: "0 8px",
          borderRadius: 7,
          border: `1px solid ${C.line}`,
          background: "#ffffff",
          color: C.ink,
          maxWidth: compact ? 190 : 320,
        }}
      >
        {BOARDS.map((b) => (
          <option key={b.path} value={b.path}>{b.label}</option>
        ))}
      </select>
    </label>
  );
}
